/**
 * @generated SignedSource<<920e6389724936f920343367286c1faa>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type DeleteBillToInput = {
  billToId: string;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type DeleteBillToMutation$variables = {
  input: DeleteBillToInput;
};
export type DeleteBillToMutation$data = {
  readonly deleteBillTo: {
    readonly deletedBillToId: string | null;
  } | null;
};
export type DeleteBillToMutation$rawResponse = {
  readonly deleteBillTo: {
    readonly deletedBillToId: string | null;
  } | null;
};
export type DeleteBillToMutation = {
  variables: DeleteBillToMutation$variables;
  response: DeleteBillToMutation$data;
  rawResponse: DeleteBillToMutation$rawResponse;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "DeleteBillToPayload",
    "kind": "LinkedField",
    "name": "deleteBillTo",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "deletedBillToId",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "DeleteBillToMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "DeleteBillToMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "08a01b18b101f620eed7f141115db26f",
    "id": null,
    "metadata": {},
    "name": "DeleteBillToMutation",
    "operationKind": "mutation",
    "text": "mutation DeleteBillToMutation(\n  $input: DeleteBillToInput!\n) {\n  deleteBillTo(input: $input) {\n    deletedBillToId\n  }\n}\n"
  }
};
})();

(node as any).hash = "9354894d3dcaa1c00ac955afa11ab527";

export default node;
